import React from "react";
// import { useContext } from "react";
// import NoteContext from "../context/notes/noteContext";

const About = () => {
  return (
    <div id="about">
      <h1 id="lol" className="mx-2 my-4">
        <u>iNotes</u>
      </h1>
      <ul className="mx-1">
        <li>
          Welcome to <b>iNotes</b>, your minimalistic note-taking experience.
        </li>
        <li className="my-3">
          With <b>iNotes</b>, you can easily create, edit, and manage your notes
          with a simple and intuitive interface.
        </li>
        <li className="my-3">
          My goal is to provide you with a distraction-free environment to help
          you stay organized and focused.
        </li>
      </ul>
      <h3 className="my-4">Guide:</h3>
      <ul>
        <li>First step is to signup and then login to access your notes.</li>
        <li className="my-3">
          To use Edit-Text feature, select the text you want to edit and click.
        </li>
        <li className="my-3">
          Undo feature is used to undo the things edited using Edit-Text.
        </li>
        <li className="my-3">
          When you are viewing your notes, try to hover sideways to get a better
          experience (On Desktop).
        </li>
        <li className="my-3">
          Add at least 5 characters in the description to save the note.
        </li>
      </ul>
      <p>
        Developed by <b id="owner">Priyanshu</b>
      </p>
    </div>
  );
};

export default About;
